import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content sub" }
const _hoisted_4 = { style: {"height":"auto"} }
const _hoisted_5 = {
  key: 1,
  class: "body_content"
}
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"30px"}
}
const _hoisted_7 = { class: "class-info-section" }
const _hoisted_8 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"15px"} }
const _hoisted_9 = {
  class: "class-info-title",
  style: {"margin-bottom":"0"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "class-header" }
const _hoisted_12 = { style: {"display":"flex","align-items":"center","gap":"8px"} }
const _hoisted_13 = {
  key: 0,
  style: {"font-size":"14px","color":"#555","background-color":"#eef2ff","padding":"4px 10px","border-radius":"4px","border":"1px solid #e0e7ff","display":"inline-flex","align-items":"center","gap":"6px","line-height":"1"}
}
const _hoisted_14 = {
  key: 1,
  style: {"color":"#d03050","font-size":"13px","display":"inline-flex","align-items":"center","gap":"4px","font-weight":"600"}
}
const _hoisted_15 = {
  key: 1,
  class: "class-entry",
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"center","min-height":"150px"}
}
const _hoisted_16 = { style: {"font-size":"16px","color":"#1e3a8a","font-weight":"600","text-align":"center"} }
const _hoisted_17 = {
  key: 1,
  style: {"margin-top":"20px","text-align":"center","color":"#888"}
}
const _hoisted_18 = {
  key: 2,
  style: {"text-align":"center","padding":"20px","color":"#888"}
}
const _hoisted_19 = {
  key: 0,
  style: {"margin-top":"0px","margin-bottom":"10px","text-align":"right"}
}

import { ref, onMounted, computed, watch, nextTick, h } from "vue";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Banner from "@/components/Banner.vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter, useRoute } from "vue-router";
import {
  NSpace,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NButton,
  NDatePicker,
  NSelect,
  NRadioGroup,
  NRadioButton,
  FormInst,
  FormRules,
  NDescriptions,
  NDescriptionsItem,
  NGrid,
  NFormItemGi,
  useMessage,
  useNotification,
  useDialog,
  NIcon,
  NInputNumber,
  NInputGroup,
  NModal,
  NDataTable,
  NCheckbox,
} from "naive-ui";
import Loading from "@/components/Loading.vue";
import { getCallable, makeCallApiParam } from "@/config/env";
import * as common from "@/assets/common/common";
import * as constant from "@/constants/constant";
import { Order, OrderItem } from "@/model/order";
import { Project } from "@/model/project";
import { Examinee } from "@/model/examinee";
import { getOrderStatusString } from "@/composables/useOrderForm";
import { WarningOutline, InformationCircleOutline } from "@vicons/ionicons5";
import { useActionDialog } from "@/composables/useDialog";
interface ProjectUIData extends Partial<Project> {
  studentCountToCreate: number | null; // 사용자가 입력하는 생성할 학생 수
}

interface ProductUIData extends Partial<OrderItem> {
  classCountToCreate: number | null; // 사용자가 입력하는 생성할 학급 수
  projects: ProjectUIData[]; // 생성된 학급 정보 배열
}

const changeOrderStatusFunc = "changeOrderStatus";

// --- 데이터 로딩 및 폼 초기화 ---
interface ValidationDetail {
  name: string;
  quantity: number;
  totalStudentsInClasses: number;
  classCount: number;
}

interface ValidateResult {
  hasExcess: boolean;
  insufficientDetails: ValidationDetail[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrgOrderProject',
  setup(__props) {

const { show: showActionDialog } = useActionDialog();
const formModel = ref<Order>({
  order_id: "",
  SK: "",
  name: "",
  cc: "",
  receiver_email: "",
  client: {
    uid: "",
    name: "",
  },
  payment_method: {
    bank_date: null,
    bank_name: "",
    deposit_name: "",
    type: "",
  },
  products: [], // 견적 항목 배열
  status: "",
  totalPrice: 0,
  type: constant.orderType.BODY,
});

// 각 상품별 UI 상태 및 학급 정보를 관리하기 위한 인터페이스
const router = useRouter();
const route = useRoute();
const message = useMessage();
const notification = useNotification();
const dialog = useDialog();

const pageLoading = ref(true);

const productEntries = ref<ProductUIData[]>([]); // 각 상품별 UI 상태 및 학급 정보를 관리
const isTemporarySaving = ref(false); // 임시저장 로딩 상태
const isStartingComplete = ref(false); // 진단 시작 로딩 상태

const classFormsRef = ref<FormInst[][]>([]); // 각 상품별, 각 학급별 폼 참조 배열 (2차원 배열)
const orderName = ref<string | null>(null);

const getOrderDetailsCallable = getCallable("getOrder");
const getCallApiCallable = getCallable("callApi");
onMounted(async () => {
  pageLoading.value = true;
  const orderSKFromRoute = route.params.SK as string;

  if (!orderSKFromRoute) {
    notification.error({
      title: "오류",
      description: "견적 정보가 올바르지 않습니다. 견적 목록으로 돌아갑니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.Mypage.Order.Org.Name }); // 견적 목록 라우트 이름으로 변경
    return;
  }

  formModel.value.SK = orderSKFromRoute; // formModel은 Order 타입이므로 SK 사용

  try {
    const result = await getOrderDetailsCallable({ SK: orderSKFromRoute });
    const orderData = common.getItemFromFunctionResult(result) as Order;

    if (orderData && orderData.products && orderData.products.length > 0) {
      orderName.value = orderData.name || "제목 없음";
      formModel.value = { ...orderData };

      productEntries.value = orderData.products.map(
        (productItem: OrderItem) => {
          const savedProjectsFromProduct: Project[] =
            (productItem as any).projects || [];

          const uiClasses: ProjectUIData[] = savedProjectsFromProduct.map(
            (dbProject: Project) => {
              return {
                ...dbProject,
                grade: dbProject.grade !== undefined && dbProject.grade !== null ? dbProject.grade.toString() : "",
                class: dbProject.class !== undefined && dbProject.class !== null ? dbProject.class.toString() : "",
                studentCountToCreate: dbProject.student_count,
              };
            }
          );

          return {
            ...productItem,
            classCountToCreate: 1,
            projects: uiClasses,
          };
        }
      );
      classFormsRef.value = productEntries.value.map(() => []);
    } else {
      notification.warning({
        title: "정보 없음",
        description: "해당 견적에 상품 정보가 없습니다.",
        duration: 3000,
      });
      router.push({ name: USER_ROUTES.Mypage.Order.Org.Name });
      return;
    }
  } catch (error: any) {
    console.error("견적 상세 정보 로딩 실패:", error);
    notification.error({
      title: "로딩 실패",
      description: error || "견적 정보를 불러오는 중 오류가 발생했습니다.",
      duration: 3000,
    });
    router.push({ name: USER_ROUTES.Mypage.Order.Org.Name }); // 오류 시 견적 목록으로 돌아가기
    return;
  } finally {
    pageLoading.value = false;
  }
});

// 화면에 표시될 상품 목록 (personal 상품만 필터링하고, 원본 인덱스 포함)
const displayedProducts = computed(() => {
  return formModel.value.products
    .map((product, originalIndex) => ({
      ...product,
      originalIndex, // 원본 배열에서의 인덱스
    }))
    .filter(
      (p) =>
        p.prod_id &&
        (p.prod_id.startsWith("personal") ||
          (p.prod_id.startsWith("activity") && p.type?.startsWith("putt_")))
    );
});

function validateStudentQuantities(): ValidateResult {
  const insufficientDetails: ValidationDetail[] = [];
  let hasExcess = false;

  for (const entry of productEntries.value) {
    let projectEntry = entry as ProductUIData;
    if (
      !(
        projectEntry.prod_id.startsWith("personal") ||
        (projectEntry.prod_id.startsWith("activity") &&
          projectEntry.type?.startsWith("putt_"))
      )
    )
      continue;
    let totalStudentsInClasses = 0;
    for (const classItem of projectEntry.projects) {
      totalStudentsInClasses += classItem.studentCountToCreate || 0; // 각 학급의 학생 수를 더함
    }
    if (totalStudentsInClasses != projectEntry.quantity) {
      const resultDetails: ValidationDetail = {
        name: projectEntry.name || "상품",
        quantity: projectEntry.quantity || 0,
        totalStudentsInClasses: totalStudentsInClasses,
        classCount: projectEntry.projects.length,
      };

      if (totalStudentsInClasses > projectEntry.quantity) {
        notification.error({
          title: "수량 초과 오류",
          description: `'${projectEntry.name}'의 총 학생 수(${totalStudentsInClasses}명)가 진단 가능 수량(${projectEntry.quantity}명)을 초과했습니다.`,
          duration: 5000,
        });
        hasExcess = true;
      } else {
        insufficientDetails.push(resultDetails);
      }
    }
  }
  return { hasExcess, insufficientDetails };
}

function makePayload(): Order {
  const payload: Order = {
    SK: formModel.value.SK,
    client: formModel.value.client,
    products: productEntries.value.map((projectEntry) => {
      const { classCountToCreate, ...restOfProductItem } = projectEntry;
      return {
        ...restOfProductItem,
        projects: projectEntry.projects.map((classItem) => {
          const { studentCountToCreate, ...restOfClassItemBase } = classItem;
          let restOfClassItem: Partial<ProjectUIData> = restOfClassItemBase;

          if (classItem.type == "putt_u" || classItem.type == "tec") {
            const { num, ...filtered } = restOfClassItem as any; // num 필드 제외 (타입에 따라)
            restOfClassItem = filtered;
          } else {
            const { major, ...filtered } = restOfClassItem as any; // major 필드 제외 (타입에 따라)
            restOfClassItem = filtered;
          }
          return { ...restOfClassItem, student_count: studentCountToCreate };
        }),
      };
    }),
  };
  return payload;
}

async function handleTemporarySave() {
  isTemporarySaving.value = true;
  try {
    const payload: Order = makePayload();
    const result = await getCallApiCallable(
      makeCallApiParam(changeOrderStatusFunc, {
        status: constant.orderStatus.APPROVED_TEMP_SAVE,
        type: constant.orderType.BODY,
        data: payload,
      })
    );
    if (common.evalFunctionResult(result)) {
      message.success("임시 저장되었습니다.");
    } else {
      throw new Error(
        common.getResultError(result) || "임시 저장 중 오류가 발생했습니다."
      );
    }
  } catch (error: any) {
    console.error("임시 저장 실패:", error);
    message.error(
      common.getResultError(error) || "임시 저장 중 오류가 발생했습니다."
    );
  } finally {
    isTemporarySaving.value = false;
  }
}

async function doComplete() {
  try {
    const payload: Order = makePayload();
    const result = await getCallApiCallable(
      makeCallApiParam(changeOrderStatusFunc, {
        status: constant.orderStatus.READY,
        type: constant.orderType.BODY,
        data: payload,
      })
    );
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "성공",
        description: "정보 등록이 성공했습니다.",
        duration: 3000,
      });
      router.push({
        name: USER_ROUTES.Mypage.Order.Org.Project.Detail.Name,
        params: { SK: payload.SK },
      });
    } else {
      throw new Error(
        common.getResultError(result) || "임시 저장 중 오류가 발생했습니다."
      );
    }
  } catch (error) {
  } finally {
    isStartingComplete.value = false;
  }
}

async function handleComplete() {
  isStartingComplete.value = true;
  let allFormsValid = true;

  for (const projectForms of classFormsRef.value) {
    for (const formRef of projectForms) {
      if (formRef) {
        try {
          await formRef.validate();
        } catch (errors) {
          allFormsValid = false;
        }
      }
    }
  }

  // 담당자 미지정 학급 수동 차단 검사
  let hasMissingManager = false;
  for (const entry of productEntries.value) {
    if (entry.projects && entry.projects.length > 0) {
      for (const proj of entry.projects) {
        if (!proj.email) {
          hasMissingManager = true;
          break;
        }
      }
    }
  }

  if (!allFormsValid || hasMissingManager) {
    if (hasMissingManager) {
      message.error("담당자가 지정되지 않은 학급(학과)이 있습니다. 담당자를 모두 지정해주세요.");
    } else {
      message.error("입력값을 확인해주세요.");
    }
    isStartingComplete.value = false;
    return;
  }

  const result = validateStudentQuantities();

  if (result.hasExcess) {
    // Already notified in validation function
    isStartingComplete.value = false;
    return;
  }

  if (result.insufficientDetails.length > 0) {
    showActionDialog({
      title: "확인",
      icon: () => h(NIcon, null, { default: () => h(WarningOutline) }),
      showIcon: true,
      style: "width: 600px;", // Increase width to accommodate details
      content: () =>
        h("div", null, [
          h(
            "div",
            {
              style:
                "max-height: 300px; overflow-y: auto; margin-bottom: 15px;",
            },
            result.insufficientDetails.map((detail) =>
              h(
                "div",
                {
                  style: {
                    marginBottom: "10px",
                    backgroundColor: "#f9f9f9",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #eee",
                  },
                },
                [
                  h(
                    "div",
                    {
                      style: {
                        fontWeight: "bold",
                        marginBottom: "5px",
                        fontSize: "1.05em",
                      },
                    },
                    detail.name
                  ),
                  h("div", `■ 전체 진단 가능 수량: ${detail.quantity}명`),
                  h("div", `■ 생성한 학급(학과) 수: ${detail.classCount}개`),
                  h(
                    "div",
                    `■ 등록한 전체 학생 수: ${detail.totalStudentsInClasses}명`
                  ),
                ]
              )
            )
          ),
          h(
            "p",
            { style: { color: "red", fontWeight: "bold", fontSize: "1.1em" } },
            "진단가능 수량보다 등록한 학생 수가 작습니다."
          ),
          h("p", "미등록 학생을 확인해 주시기 바랍니다."),
          h(
            "p",
            { style: { color: "red", fontWeight: "bold", marginTop: "10px" } },
            "그래도 계속 진행 하시겠습니까?"
          ),
        ]),
      positiveText: "예",
      negativeText: "아니요",
      confirmButtonLoadingText: "처리 중...",
      onConfirm: () => {
        doComplete();
      },
      onCancel: () => {
        isStartingComplete.value = false;
      },
    });
  } else {
    doComplete();
  }
}
function handleCancel() {
  router.push({ name: USER_ROUTES.Mypage.Order.Org.Name });
}

function createClassForms(projectIndex: number) {
  const entry = productEntries.value[projectIndex];
  if (entry && entry.classCountToCreate && entry.classCountToCreate > 0) {
    // entry.projects = []; // 기존 학급 정보 초기화 (또는 필요에 따라 추가하는 로직으로 변경)
    const currentProjectCount = entry.projects.length; // 현재 학급/학과 수
    for (let i = 0; i < entry.classCountToCreate; i++) {
      const newProjectNum = currentProjectCount + i + 1;
      entry.projects.push({
        name: entry.name,
        num: newProjectNum,
        grade: "1",
        class: newProjectNum.toString(),
        type: entry.type,
        start_target_date: null,
        end_target_date: null,
        status: constant.projectStatus.PENDING,
        studentCountToCreate: 1, // 초기 학생 수는 1로 설정
      });
    }
    // 학급 폼 참조 배열 초기화 (새로 생성된 학급 수에 맞게)
    classFormsRef.value[projectIndex] = Array(entry.projects.length).fill(null);
  } else {
    message.warning("생성할 학급 수를 1 이상으로 입력해주세요.");
  }
}
// 학급 삭제 버튼 클릭 시
function deleteClassForm(projectIndex: number, classIndex: number) {
  const entry = productEntries.value[projectIndex];
  if (entry && entry.projects && entry.projects.length > classIndex) {
    entry.projects.splice(classIndex, 1);
    // 해당 학급의 폼 참조 제거
    classFormsRef.value[projectIndex].splice(classIndex, 1);
    message.success("학급이 삭제되었습니다.");
  }
}

// createExamineeForms 함수 제거
// deleteExamineeForm 함수 제거

// 학급 폼 유효성 검사 규칙 생성 함수
const classFormRules = (
  projectIndex: number,
  classIndex: number
): FormRules => {
  const rules: FormRules = {};
  rules.name = [
    {
      required: true,
      message: "학급/학과명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ];
  rules.major = [
    {
      required: true,
      message: "전공/학과명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ];

  // Grade and Class rules might depend on the product type
  const productType = productEntries.value[projectIndex]?.type;
  if (!(productType === "putt_u" || productType === "tec")) {
    rules.grade = [
      {
        type: "string",
        required: true,
        message: "학년을 입력해주세요.",
        trigger: ["input", "blur", "change"],
      },
    ];
    rules.class = [
      {
        type: "string",
        required: true,
        message: "반을 입력해주세요.",
        trigger: ["input", "blur", "change"],
      },
    ];
  }
  rules.email = [
    {
      required: true,
      message: "담당자를 지정해주세요.",
      trigger: "change",
    },
  ];
  rules.start_target_date = [
    {
      required: true,
      message: "진단 시작 시간을 선택해주세요.",
      trigger: "change",
    },
  ];
  rules.end_target_date = [
    {
      required: true,
      message: "진단 종료 시간을 선택해주세요.",
      trigger: "change",
    },
  ];

  // 학생 정보 관련 유효성 검사 규칙 제거
  return rules;
};

// 담당자 지정 관련 상태 및 함수
const isManagerModalOpen = ref(false);
const orgMembers = ref<any[]>([]);
const loadingMembers = ref(false);
const activeTarget = ref<{ productIndex: number; projectIndex: number } | null>(null);
const memberSearchQuery = ref("");
const isIncludeAdmin = ref(false);

const getOrgMembersCallable = getCallable("getOrgMembers");

const filteredOrgMembers = computed(() => {
  return orgMembers.value.filter((member) => {
    // 1. 관리자 포함 여부 필터
    if (!isIncludeAdmin.value && member.type === "admin") {
      return false;
    }
    // 2. 이름 또는 이메일 검색 필터
    if (memberSearchQuery.value.trim()) {
      const q = memberSearchQuery.value.toLowerCase().trim();
      const nameMatch = member.name?.toLowerCase().includes(q);
      const emailMatch = member.email?.toLowerCase().includes(q);
      return nameMatch || emailMatch;
    }
    return true;
  });
});

async function openManagerSelectModal(productIndex: number, projectIndex: number) {
  activeTarget.value = { productIndex, projectIndex };
  isManagerModalOpen.value = true;
  loadingMembers.value = true;
  orgMembers.value = [];
  memberSearchQuery.value = "";
  isIncludeAdmin.value = false;
  try {
    console.log("=== openManagerSelectModal Debug ===");
    console.log("formModel SK:", formModel.value?.SK);
    console.log("formModel client:", JSON.stringify(formModel.value?.client));
    
    const clientUid = formModel.value.client?.uid;
    let orgId = "";
    if (clientUid) {
      orgId = clientUid.includes("#") ? clientUid.split("#")[1] : clientUid;
      console.log("Case 1: Found clientUid. Selected orgId:", orgId);
    } else {
      const parts = formModel.value.SK.split("#");
      console.log("Case 2: Fallback to SK parts:", parts);
      if (parts[0] === "org" && parts[1] === "org") {
        orgId = parts[2];
      } else {
        orgId = parts[1];
      }
      console.log("Selected orgId from parts:", orgId);
    }
    
    console.log("Final orgId parameter to call API:", orgId);
    const result = await getOrgMembersCallable({ orgId });
    const list = common.getItemListFromFunctionResult(result) || [];
    orgMembers.value = list;
  } catch (error) {
    console.error("기관 멤버 조회 실패:", error);
    message.error("기관 멤버 정보를 불러오는데 실패했습니다.");
  } finally {
    loadingMembers.value = false;
  }
}

function selectManager(row: any) {
  if (activeTarget.value) {
    const { productIndex, projectIndex } = activeTarget.value;
    const project = productEntries.value[productIndex].projects[projectIndex];
    project.email = row.email;
    project.manager_name = row.name;
    project.manager_role = row.role || "";
    project.manager_position = row.position || "";
    
    project.manager_id = row.SK.split("#").pop() || "";
  }
  isManagerModalOpen.value = false;
}

function getManagerDisplayText(classItem: any) {
  if (!classItem || !classItem.email) return "";
  const parts = [];
  if (classItem.manager_name) {
    parts.push(`${classItem.manager_name} (${classItem.email})`);
  } else {
    parts.push(classItem.email);
  }
  if (classItem.manager_role) {
    parts.push(classItem.manager_role);
  }
  if (classItem.manager_position) {
    parts.push(classItem.manager_position);
  }
  return parts.join(" / ");
}

const memberTableColumns = [
  {
    title: "이름",
    key: "name",
  },
  {
    title: "이메일",
    key: "email",
  },
  {
    title: "역할",
    key: "role",
    render(row: any) {
      return row.role || "-";
    }
  },
  {
    title: "직책",
    key: "position",
    render(row: any) {
      return row.position || "-";
    }
  },
  {
    title: "구분",
    key: "type",
    render(row: any) {
      return row.type === "admin" ? "관리자" : "사용자";
    }
  },
  {
    title: "선택",
    key: "actions",
    render(row: any) {
      return h(
        NButton,
        {
          size: "small",
          type: "info",
          onClick: () => selectManager(row),
        },
        { default: () => "선택" }
      );
    },
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(Loading, null, null, 512), [
      [_vShow, pageLoading.value]
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MyPageSidebar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_unref(NSpace), { vertical: "" }, {
            default: _withCtx(() => [
              _createVNode(_unref(NCard), { style: {"margin-top":"20px","margin-left":"80px","border":"0px","min-width":"800px","max-width":"1000px"} }, {
                default: _withCtx(() => [
                  _createVNode(_unref(NSpace), {
                    "item-style": "display: flex;",
                    align: "center"
                  }, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createElementVNode("div", { style: {"font-size":"20px","font-weight":"bold"} }, " 진단 정보 등록 ", -1)
                    ])),
                    _: 1
                  }),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "content_delimiter_line" }, null, -1)),
                  (pageLoading.value)
                    ? (_openBlock(), _createBlock(Loading, { key: 0 }))
                    : (formModel.value.SK)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_unref(NDescriptions), {
                            "label-placement": "left",
                            bordered: "",
                            column: 2,
                            size: "small",
                            title: "진단 기본 정보"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_unref(NDescriptionsItem), {
                                label: "기관명",
                                span: 3
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(formModel.value.client?.name || "N/A"), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NDescriptionsItem), { label: "상태" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_unref(getOrderStatusString)(formModel.value.status)), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_unref(NDescriptionsItem), { label: "생성일" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(formModel.value.createdDate
                        ? common.getYYYYMMDD2(
                            new Date(Number(formModel.value.createdDate))
                          )
                        : "N/A"), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (formModel.value.products && formModel.value.products.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _cache[12] || (_cache[12] = _createElementVNode("h3", {
                                  class: "form-section-title",
                                  style: {"border-bottom":"none","margin-bottom":"10px"}
                                }, " 진단 목록 ", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayedProducts.value, (productView, displayIndex) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    key: productView.prod_id,
                                    class: "product-item-card"
                                  }, [
                                    _createVNode(_unref(NDescriptions), {
                                      "label-placement": "left",
                                      bordered: "",
                                      column: 3,
                                      size: "small"
                                    }, {
                                      header: _withCtx(() => [
                                        _createTextVNode(" 진단 " + _toDisplayString(displayIndex + 1) + ": " + _toDisplayString(productView.name), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_unref(NDescriptionsItem), {
                                          label: "수량",
                                          class: "quantity-item"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(productView.quantity), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_unref(NDescriptionsItem), {
                                          label: "비고",
                                          span: 2
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(productView.notes || "N/A"), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("h4", _hoisted_9, _toDisplayString(productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과 정보"
                                : "학급 정보"), 1),
                                        _createVNode(_unref(NSpace), null, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(NFormItem), {
                                              "label-placement": "left",
                                              label: 
                                productView.type === 'putt_u' ||
                                productView.type === 'tec'
                                  ? '학과 수'
                                  : '학급 수'
                              ,
                                              "show-feedback": false,
                                              style: {"margin-bottom":"0"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(NInputNumber), {
                                                  value: productEntries.value[productView.originalIndex]!.classCountToCreate,
                                                  "onUpdate:value": ($event: any) => ((productEntries.value[productView.originalIndex]!.classCountToCreate) = $event),
                                                  min: 1,
                                                  placeholder: 
                                  productView.type === 'putt_u' ||
                                  productView.type === 'tec'
                                    ? '학과 수'
                                    : '학급 수'
                                
                                                }, null, 8, ["value", "onUpdate:value", "placeholder"])
                                              ]),
                                              _: 2
                                            }, 1032, ["label"]),
                                            _createVNode(_unref(NButton), {
                                              type: "info",
                                              onClick: ($event: any) => (
                                createClassForms(productView.originalIndex)
                              )
                                            }, {
                                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                _createTextVNode("학급 생성")
                                              ])),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      (
                            productEntries.value[productView.originalIndex]
                              .projects &&
                            productEntries.value[productView.originalIndex].projects
                              .length > 0
                          )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productEntries.value[
                              productView.originalIndex
                            ].projects, (classItem, classIdx) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: classIdx,
                                                class: "class-entry"
                                              }, [
                                                _createVNode(_unref(NForm), {
                                                  ref_for: true,
                                                  ref: 
                                (el) =>
                                  (classFormsRef.value[productView.originalIndex][
                                    classIdx
                                  ] = el)
                              ,
                                                  model: classItem,
                                                  rules: 
                                classFormRules(
                                  productView.originalIndex,
                                  classIdx
                                )
                              ,
                                                  "label-placement": "top"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_11, [
                                                      _createElementVNode("h4", null, _toDisplayString(productView.type === "putt_u" ||
                                    productView.type === "tec"
                                      ? "학과"
                                      : "학급") + " " + _toDisplayString(classIdx + 1) + " 정보 ", 1),
                                                      _createVNode(_unref(NFormItem), {
                                                        "show-label": false,
                                                        "show-feedback": false,
                                                        path: "email",
                                                        style: {"margin":"0 0 0 20px"}
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_12, [
                                                            _createVNode(_unref(NButton), {
                                                              type: classItem.email ? 'info' : 'error',
                                                              size: "small",
                                                              ghost: !!classItem.email,
                                                              onClick: ($event: any) => (openManagerSelectModal(productView.originalIndex, classIdx))
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(classItem.email ? '담당자 변경' : '담당자 지정'), 1)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["type", "ghost", "onClick"]),
                                                            (classItem.email)
                                                              ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                                  _cache[5] || (_cache[5] = _createElementVNode("strong", null, "이름:", -1)),
                                                                  _createTextVNode(" " + _toDisplayString(classItem.manager_name) + " | ", 1),
                                                                  _cache[6] || (_cache[6] = _createElementVNode("strong", null, "이메일:", -1)),
                                                                  _createTextVNode(" " + _toDisplayString(classItem.email) + " | ", 1),
                                                                  _cache[7] || (_cache[7] = _createElementVNode("strong", null, "역할:", -1)),
                                                                  _createTextVNode(" " + _toDisplayString(classItem.manager_role || '-') + " | ", 1),
                                                                  _cache[8] || (_cache[8] = _createElementVNode("strong", null, "직책:", -1)),
                                                                  _createTextVNode(" " + _toDisplayString(classItem.manager_position || '-'), 1)
                                                                ]))
                                                              : (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                                  _createVNode(_unref(NIcon), { size: "16" }, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_unref(WarningOutline))
                                                                    ]),
                                                                    _: 1
                                                                  }),
                                                                  _cache[9] || (_cache[9] = _createTextVNode(" 담당자 지정이 필요합니다. "))
                                                                ]))
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1024),
                                                      _createVNode(_unref(NButton), {
                                                        type: "error",
                                                        ghost: "",
                                                        size: "small",
                                                        onClick: ($event: any) => (
                                    deleteClassForm(
                                      productView.originalIndex,
                                      classIdx
                                    )
                                  ),
                                                        style: {"margin-left":"auto"}
                                                      }, {
                                                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                          _createTextVNode(" 학급 삭제 ")
                                                        ])),
                                                        _: 2
                                                      }, 1032, ["onClick"])
                                                    ]),
                                                    (productView.type === 'putt_u' || productView.type === 'tec')
                                                      ? (_openBlock(), _createBlock(_unref(NGrid), {
                                                          key: 0,
                                                          cols: 12,
                                                          "x-gap": 12
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              label: `전공`,
                                                              span: 6,
                                                              path: "major"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NInput), {
                                                                  value: classItem.major,
                                                                  "onUpdate:value": ($event: any) => ((classItem.major) = $event),
                                                                  placeholder: '학과명 (예: 컴퓨터공학과)'
                                                                }, null, 8, ["value", "onUpdate:value"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              label: "학생 수",
                                                              "label-placement": "left",
                                                              "label-width": "100px",
                                                              span: 6,
                                                              path: "studentCountToCreate"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NInputNumber), {
                                                                  value: classItem.studentCountToCreate,
                                                                  "onUpdate:value": ($event: any) => ((classItem.studentCountToCreate) = $event),
                                                                  min: 1,
                                                                  placeholder: "학급(학과)의 총 학생 수",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["value", "onUpdate:value"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              "label-width": "90px",
                                                              span: 4,
                                                              label: "진단 시작일",
                                                              path: "start_target_date"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NDatePicker), {
                                                                  "formatted-value": classItem.start_target_date,
                                                                  "onUpdate:formattedValue": ($event: any) => ((classItem.start_target_date) = $event),
                                                                  "value-format": "yyyy-MM-dd",
                                                                  type: "date",
                                                                  placeholder: "시작일 선택",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["formatted-value", "onUpdate:formattedValue"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              "label-width": "90px",
                                                              span: 4,
                                                              label: "진단 종료일",
                                                              path: "end_target_date"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NDatePicker), {
                                                                  "formatted-value": classItem.end_target_date,
                                                                  "onUpdate:formattedValue": ($event: any) => ((classItem.end_target_date) = $event),
                                                                  "value-format": "yyyy-MM-dd",
                                                                  type: "date",
                                                                  placeholder: "종료일 선택",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["formatted-value", "onUpdate:formattedValue"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : (_openBlock(), _createBlock(_unref(NGrid), {
                                                          key: 1,
                                                          cols: 12,
                                                          "x-gap": 12
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              "label-width": "90px",
                                                              span: 4,
                                                              label: `학년`,
                                                              path: "grade"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NInput), {
                                                                  value: classItem.grade,
                                                                  "onUpdate:value": ($event: any) => ((classItem.grade) = $event),
                                                                  placeholder: "학년 (예: 1)",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["value", "onUpdate:value"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              "label-width": "90px",
                                                              span: 4,
                                                              label: `반`,
                                                              path: "class"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NInput), {
                                                                  value: classItem.class,
                                                                  "onUpdate:value": ($event: any) => ((classItem.class) = $event),
                                                                  placeholder: "반 (예: 1A)",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["value", "onUpdate:value"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              label: "학생 수",
                                                              "label-placement": "left",
                                                              "label-width": "100px",
                                                              span: 4,
                                                              path: "studentCountToCreate"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NInputNumber), {
                                                                  value: classItem.studentCountToCreate,
                                                                  "onUpdate:value": ($event: any) => ((classItem.studentCountToCreate) = $event),
                                                                  min: 1,
                                                                  placeholder: "학급(학과)의 총 학생 수",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["value", "onUpdate:value"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              "label-width": "90px",
                                                              span: 4,
                                                              label: "진단 시작일",
                                                              path: "start_target_date"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NDatePicker), {
                                                                  "formatted-value": classItem.start_target_date,
                                                                  "onUpdate:formattedValue": ($event: any) => ((classItem.start_target_date) = $event),
                                                                  "value-format": "yyyy-MM-dd",
                                                                  type: "date",
                                                                  placeholder: "시작일 선택",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["formatted-value", "onUpdate:formattedValue"])
                                                              ]),
                                                              _: 2
                                                            }, 1024),
                                                            _createVNode(_unref(NFormItemGi), {
                                                              "label-placement": "left",
                                                              "label-width": "90px",
                                                              span: 4,
                                                              label: "진단 종료일",
                                                              path: "end_target_date"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_unref(NDatePicker), {
                                                                  "formatted-value": classItem.end_target_date,
                                                                  "onUpdate:formattedValue": ($event: any) => ((classItem.end_target_date) = $event),
                                                                  "value-format": "yyyy-MM-dd",
                                                                  type: "date",
                                                                  placeholder: "종료일 선택",
                                                                  style: {"width":"100%"}
                                                                }, null, 8, ["formatted-value", "onUpdate:formattedValue"])
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["model", "rules"])
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                            _createVNode(_unref(NIcon), {
                                              size: "32",
                                              color: "#aaa",
                                              style: {"margin-bottom":"10px"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_unref(InformationCircleOutline))
                                              ]),
                                              _: 1
                                            }),
                                            _createElementVNode("div", _hoisted_16, [
                                              _createTextVNode(" 우측 상단의 '추가할 " + _toDisplayString(productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과"
                                : "학급") + " 수'를 입력 후 '" + _toDisplayString(productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과"
                                : "학급") + " 생성' 버튼을 눌러주세요.", 1),
                                              _cache[11] || (_cache[11] = _createElementVNode("br", null, null, -1)),
                                              _createTextVNode(" 생성된 각 " + _toDisplayString(productView.type === "putt_u" ||
                              productView.type === "tec"
                                ? "학과"
                                : "학급") + "에 진단 인원을 입력하여 진행할 수 있습니다. ", 1)
                                            ])
                                          ]))
                                    ])
                                  ]))
                                }), 128))
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_17, " 견적에 포함된 상품이 없습니다. "))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, " 견적 정보를 불러오지 못했습니다. "))
                ]),
                _: 1
              }),
              (
                formModel.value.SK &&
                formModel.value.products &&
                formModel.value.products.length > 0
              )
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_unref(NButton), {
                      type: "tertiary",
                      onClick: handleCancel,
                      style: {"margin-right":"12px"}
                    }, {
                      default: _withCtx(() => _cache[14] || (_cache[14] = [
                        _createTextVNode(" 취소 ")
                      ])),
                      _: 1
                    }),
                    _createVNode(_unref(NButton), {
                      type: "default",
                      onClick: handleTemporarySave,
                      loading: isTemporarySaving.value,
                      style: {"margin-right":"12px"}
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode(" 임시저장 ")
                      ])),
                      _: 1
                    }, 8, ["loading"]),
                    _createVNode(_unref(NButton), {
                      type: "primary",
                      onClick: handleComplete,
                      loading: isStartingComplete.value
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode(" 작성완료 ")
                      ])),
                      _: 1
                    }, 8, ["loading"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_unref(NModal), {
      show: isManagerModalOpen.value,
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => ((isManagerModalOpen).value = $event)),
      preset: "card",
      title: "담당자 지정",
      style: {"width":"700px","max-width":"90%"},
      bordered: false
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(NSpace), {
          vertical: "",
          size: 12
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NSpace), {
              align: "center",
              justify: "space-between"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(NInput), {
                  value: memberSearchQuery.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((memberSearchQuery).value = $event)),
                  placeholder: "이름 또는 이메일 검색",
                  clearable: "",
                  style: {"width":"250px"}
                }, null, 8, ["value"]),
                _createVNode(_unref(NCheckbox), {
                  checked: isIncludeAdmin.value,
                  "onUpdate:checked": _cache[1] || (_cache[1] = ($event: any) => ((isIncludeAdmin).value = $event))
                }, {
                  default: _withCtx(() => _cache[17] || (_cache[17] = [
                    _createTextVNode(" 관리자 포함 ")
                  ])),
                  _: 1
                }, 8, ["checked"])
              ]),
              _: 1
            }),
            _createVNode(_unref(NDataTable), {
              loading: loadingMembers.value,
              columns: memberTableColumns,
              data: filteredOrgMembers.value,
              pagination: { pageSize: 5 },
              "row-key": (row) => row.SK
            }, null, 8, ["loading", "data", "row-key"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})